/*

  ______  _____   ______ _______  ______
 |_____/ |     | |  ____ |______ |_____/
 |    \_ |_____| |_____| |______ |    \_

 vehicle sales system

(c) 2006 - 2019 TCE <TCE-ITDevelopers@toyota-ce.com>

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/

"use strict";

const angular = require("angular");

require("angular-route");
require("ngstorage");
require("angular-ui-bootstrap");
require("angular-ui-switch");
require("angular-ui-validate");
require("ui-select");
require("angular-translate");
require("@tce/kobe-oidc");
require("linq");
require("string");
require("angular-file-saver");
require("ng-file-upload");
require("angular-messages");
require("angular-file-upload");
require("angular-sanitize");

angular
    .module("ROGER", [
        "ngRoute",
        "ngMessages",
        "ngStorage",
        "ui.bootstrap",
        "ui.select",
        "uiSwitch",
        "ui.validate",
        "pascalprecht.translate",
        "kobeOIDC",
        "ngFileSaver",
        "ngFileUpload",
        "angularFileUpload",
        "ngSanitize"
    ]);

require("./Common");
require("./Config");
require("./Routing");
require("./AppController");
require("./UserService");
require("./VersionUpdateController");

require("./Auth");
require("./Notifications");
require("./Progress");
require("./MessageBox");
require("./DecisionBox");
require("./Well");
require("./Customer");
require("./GraphService");
require("./AddressLookupService");

require("./Bonus");
require("./Car");
require("./Dashboard");
require("./Event");
require("./Finance");
require("./Invoice");
require("./Model");
require("./Reservation");
require("./Retail");
require("./Shopping");
require("./Sale");
require("./Show");
require("./Report");
require("./TradeIn");
require("./TradeInApproval");
require("./NoPermissions");

require("../assets/Styles.less");